// extracted by mini-css-extract-plugin
module.exports = {"btns_action":"PopupMenu_btns_action__1AgUG"};